// Yanlış firma cache'lerini temizlemek için utility
export const clearWrongFirmaCache = () => {
  console.log('🧹 Yanlış firma cache temizliği başlıyor...');
  
  // 1. Temp session temizle
  const tempSession = localStorage.getItem('temp_user_session');
  if (tempSession) {
    try {
      const sessionData = JSON.parse(tempSession);
      console.log('📋 Mevcut temp session:', sessionData);
      
      // Eğer Ekoİştirak-1 varsa temizle
      if (sessionData.userFirmas?.some((f: any) => f.firma_adi === 'Ekoİştirak-1')) {
        localStorage.removeItem('temp_user_session');
        console.log('🗑️ Yanlış temp session temizlendi');
      }
    } catch (error) {
      console.log('❌ Temp session parse hatası:', error);
      localStorage.removeItem('temp_user_session');
    }
  }
  
  // 2. Selected firma temizle
  const selectedFirma = localStorage.getItem('selectedFirma');
  if (selectedFirma) {
    try {
      const firmaData = JSON.parse(selectedFirma);
      console.log('📋 Mevcut selectedFirma:', firmaData);
      
      // Eğer Ekoİştirak-1 seçiliyse temizle
      if (firmaData.firma_adi === 'Ekoİştirak-1' || firmaData.label === 'Ekoİştirak-1') {
        localStorage.removeItem('selectedFirma');
        console.log('🗑️ Yanlış selectedFirma temizlendi');
      }
    } catch (error) {
      console.log('❌ SelectedFirma parse hatası:', error);
      localStorage.removeItem('selectedFirma');
    }
  }
  
  // 3. Form cache'lerini temizle
  const keysToRemove: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && (
      key.includes('isg_form_data_') ||
      key.includes('sera_gazi_form_data_') ||
      key.includes('isgucuverileri_form_data_') ||
      key.includes('su_form_data_') ||
      key.includes('Ekoİştirak-1') ||
      key.includes('form_data_') && key.includes('_2025')
    )) {
      keysToRemove.push(key);
    }
  }
  
  keysToRemove.forEach(key => {
    localStorage.removeItem(key);
    console.log('🗑️ Form cache temizlendi:', key);
  });
  
  // 4. Diğer ilgili cache'leri temizle
  const otherKeys = [
    'userFirmaOptions',
    'lastSelectedFirma',
    'firmaCache',
    'authCache'
  ];
  
  otherKeys.forEach(key => {
    if (localStorage.getItem(key)) {
      localStorage.removeItem(key);
      console.log('🗑️ Cache temizlendi:', key);
    }
  });
  
  console.log('✅ Cache temizliği tamamlandı');
  
  // 5. Sayfayı yenile
  setTimeout(() => {
    console.log('🔄 Sayfa yenileniyor...');
    window.location.reload();
  }, 1000);
};

// Otomatik temizlik - sayfa yüklendiğinde çalışır
export const autoCleanWrongFirmaCache = () => {
  const selectedFirma = localStorage.getItem('selectedFirma');
  if (selectedFirma) {
    try {
      const firmaData = JSON.parse(selectedFirma);
      if (firmaData.firma_adi === 'Ekoİştirak-1' || firmaData.label === 'Ekoİştirak-1') {
        console.log('⚠️ Yanlış firma cache tespit edildi, otomatik temizlik yapılıyor...');
        clearWrongFirmaCache();
      }
    } catch (error) {
      console.log('❌ Auto clean parse hatası:', error);
    }
  }
};